import { render } from "./dialog-upload.vue?vue&type=template&id=2db22b0f"
import script from "./dialog-upload.vue?vue&type=script&lang=js"
export * from "./dialog-upload.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/cdas-intranet-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__